import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
import runEngine from '../engine';

import { set } from './helpers';
import state from './state';
import getters from './getters';
import * as actions from './actions';

Vue.use(Vuex);

const VuexEngineRun = _.debounce((store, mutation, stateObject) => {
  // It's bad practice to set directly on the state in middleware
  // but it just seems wrong to trigger another mutation here!
  const allowedEngineMutations = ['router/ROUTE_CHANGED', 'SET_STORE_VALUE'];
  if (_.indexOf(allowedEngineMutations, mutation.type) >= 0) {
    store.commit('SET_RESULT_VALUE', runEngine(stateObject));
    // console.log('Results', store.state.results);
    // _.set(state, 'results', );
  }
}, 375);

// Allows us to subscribe to property mutations
function VuexEngine(store) {
  store.subscribe.call(store, VuexEngineRun.bind(store, store));
}

export default new Vuex.Store({
  state: _.defaultsDeep({ results: runEngine(state) }, state),
  getters,
  mutations: {
    SET_STORE_VALUE: set,
    SET_UI_VALUE: set,
    /* eslint-disable no-param-reassign */
    SET_RESULT_VALUE(storeObject, results) {
      storeObject.results = results;
    },
    /* eslint-enable */
  },
  actions,
  plugins: [VuexEngine],
});
